export const environment = {
  production: false,
  API_URL_PROD_MRH:"https://us-central1-salix-90588.cloudfunctions.net/app/primemrh",
  API_URL_PROD_NOTIFY:"https://us-central1-salix-90588.cloudfunctions.net/app/sendnotify",
  API_URL_VERIFY :"https://us-central1-salix-90588.cloudfunctions.net/app/verify_user",
  API_URL_VERIFY_DEMO:"http://localhost:5001/salix-90588/us-central1/app/verify_user",
  API_URL_RECOVER: "https://us-central1-salix-90588.cloudfunctions.net/app/reset_user",
  RACINE : '@asapa.ga',
 firebaseConfig: {
    apiKey: "AIzaSyDYKx3ck8-GC14ushDuToYBR3o2hAwQJxE",
    authDomain: "salix-90588.firebaseapp.com",
    databaseURL: "https://salix-90588.firebaseio.com",
    projectId: "salix-90588",
    storageBucket: "salix-90588.appspot.com",
    messagingSenderId: "77177038730",
    appId: "1:77177038730:web:e5f5da2ffe34c549fe8a73",
    measurementId: "G-YCYNP0MDNJ"
  }
};
